import { STATIC_IMAGES } from "utils/url.utils";

// Period Length Select
export enum PERIOD_LENGTH_SELECT_NAMES {
  Up_to_6_months = "Up_to_6_months",
  Up_to_1_year = "Up_to_1_year",
  Up_to_3_years = "Up_to_3_year",
  Up_to_5_years = "Up_to_5_year",
  All = "All",
}

export enum PERIOD_LENGTH_SELECT_VALUES {
  Up_to_6_months = "Up To 6 Months",
  Up_to_1_year = "Up To 1 Year",
  Up_to_3_year = "Up To 3 Years",
  Up_to_5_year = "Up To 5 Years",
  All = "All",
}

//Shipping select
export enum SHIPPING_SELECT_NAMES {
  FCL_SEA = "FCL_sea",
  LCL_SEA = "LCL_sea",
  BULK = "Bulk",
  FCL_ROAD = "FCL_road",
  FTL_ROAD = "FTL_road",
  LTL_ROAD = "LTL_road",
  FCL_RAIL = "FCL_rail",
  FWL = "FWL",
  LWL = "LWL",
  FTL_RAIL = "FTL_rail",
  STANDARD_CARGO = "Standard_cargo",
  ULD = "ULD",
  MA = "MA",
  ESE = "ESE",
  PT = "PT",
}

export enum SHIPPING_SELECT_VALUES {
  "FCL_sea" = "FCL sea",
  "LCL_sea" = "LCL sea",
  "Bulk" = "Bulk",
  "FCL_road" = "FCL road",
  "FTL_road" = "FTL road",
  "LTL_road" = "LTL road",
  "FCL_rail" = "FCL rail",
  "FWL" = "FWL",
  "LWL" = "LWL",
  "FTL_rail" = "FTL rail",
  "Standard_cargo" = "Standard cargo",
  "ULD" = "ULD",
  "ESE" = "ESE",
  "MA" = "MA",
  "PT" = "PT",
}

// Timeline select
export enum TIMELINE_SELECT_NAMES {
  Asap = "Asap",
  Month_1_3 = "Month_1_3",
  Month_3_6 = "Month_3_6",
  Later = "Later",
}

export enum TIMELINE_SELECT_VALUES {
  Asap = "ASAP",
  Month_1_3 = "1-3 months",
  Month_3_6 = "3-6 months",
  Later = "Later",
}

//Tool
export enum TOOL_NAMES {
  CT = "container-tracking",
  AT = "air-tracking",
  CLO = "cargo-load-optimizer",
  VS = "vessel-schedules",
  TT = "transit-time",
  CO2 = "co2",
  // RE = "rate-engine",
}

export enum TOOL_VALUES {
  "container-tracking" = "Container Tracking",
  "cargo-load-optimizer" = "Cargo Load Optimizer",
  "air-tracking" = "Air Tracking",
  "vessel-schedules" = "Vessel Schedules",
  "transit-time" = "Transit Time",
  "co2" = "CO2",
  // "rate-engine" = "Rate Engine",
}

export const TOOL_ICONS = {
  [TOOL_NAMES.CT]: (
    <img width={22} height={22} src={`${STATIC_IMAGES}/tool/ContainerTrackingIcon.webp`} alt="ContainerTracking" />
  ),
  [TOOL_NAMES.AT]: (
    <img width={22} height={22} src={`${STATIC_IMAGES}/tool/AirTrackignIconV2.webp`} alt="AirTracking" />
  ),
  [TOOL_NAMES.VS]: (
    <img width={22} height={22} src={`${STATIC_IMAGES}/tool/VesselSchedulesIcon.webp`} alt="VesselSchedules" />
  ),
  [TOOL_NAMES.TT]: <img width={22} height={22} src={`${STATIC_IMAGES}/tool/TransitTimeIcon.webp`} alt="TransitTime" />,
  [TOOL_NAMES.CO2]: (
    <img
      width={22}
      height={22}
      src={`${STATIC_IMAGES}/tool/CarbonEmissionsCalculatorIcon.webp`}
      alt="CarbonEmissionsCalculator"
    />
  ),
  [TOOL_NAMES.CLO]: (
    <img width={22} height={22} src={`${STATIC_IMAGES}/tool/CargoLoadOptimizer.webp`} alt="CargoLoadOptimizer" />
  ),
  // [TOOL_NAMES.RE]: <img src={`${STATIC_IMAGES}/tool/RateEngineIcon.png`} alt="RateEngine" />,
} as const;

export const TOOL_NAMES_CONTENT = [
  {
    name: TOOL_NAMES.CT,
    value: TOOL_VALUES[TOOL_NAMES.CT],
    icon: TOOL_ICONS[TOOL_NAMES.CT],
  },
  {
    name: TOOL_NAMES.AT,
    value: TOOL_VALUES[TOOL_NAMES.AT],
    icon: TOOL_ICONS[TOOL_NAMES.AT],
  },
  {
    name: TOOL_NAMES.CLO,
    value: TOOL_VALUES[TOOL_NAMES.CLO],
    icon: TOOL_ICONS[TOOL_NAMES.CLO],
  },
  // {
  //   name: TOOL_NAMES.RE,
  //   value: TOOL_VALUES[TOOL_NAMES.RE],
  //   icon: TOOL_ICONS[TOOL_NAMES.RE],
  // },
  {
    name: TOOL_NAMES.TT,
    value: TOOL_VALUES[TOOL_NAMES.TT],
    icon: TOOL_ICONS[TOOL_NAMES.TT],
  },
  {
    name: TOOL_NAMES.VS,
    value: TOOL_VALUES[TOOL_NAMES.VS],
    icon: TOOL_ICONS[TOOL_NAMES.VS],
  },
  {
    name: TOOL_NAMES.CO2,
    value: TOOL_VALUES[TOOL_NAMES.CO2],
    icon: TOOL_ICONS[TOOL_NAMES.CO2],
  },
];

//Request type
export enum REQUEST_TYPE_NAMES {
  web = "web",
  app = "app",
  api = "api",
}

export enum REQUEST_TYPE_VALUES {
  "web" = "Web access",
  "app" = "App integration",
  "api" = "API",
}

export const REQUEST_TYPE_OPTIONS = [
  {
    name: REQUEST_TYPE_NAMES.web,
    value: REQUEST_TYPE_VALUES[REQUEST_TYPE_NAMES.web],
  },
  {
    name: REQUEST_TYPE_NAMES.app,
    value: REQUEST_TYPE_VALUES[REQUEST_TYPE_NAMES.app],
  },
  {
    name: REQUEST_TYPE_NAMES.api,
    value: REQUEST_TYPE_VALUES[REQUEST_TYPE_NAMES.api],
  },
];
